<template>
  <!--  客服 按钮-->
  <div class="customer_service" :style="{top: position + 'px'}" @click="toCustomerService"></div>
</template>
<script>
export default {
  name: 'customerService',
  props: {
    position: {
      type: Number,
      default: 133 / 2
    }
  },
  methods: {
    toCustomerService() {
      const userId = this.$xesCookie.get('stu_id') || ''
      window.location.href = `https://app.xueersi.com/polymerh5/app/#/chat?key=7&userId=${userId}&closeWindow=0&channel=3&orderId=4&channelId=29&courseId=6&type=7&grade=&rregion=11-22-33-44`
      // window.location.href = `https://chat.sobot.com//chat//h5//v2//index.html?sysnum=4a1c52959a974dd497260f4e0d50f1c9&channelid=31&partnerid=${userId}&source=2&robotid=2`
    }
  }
}
</script>
<style lang="less">
.customer_service {
  position: fixed;
  top: 133/2px;
  right: 0;
  z-index: 2;
  width: 108/2px;
  height: 52/2px;
  background-image: url("../assets/images/customerService.png");
  background-size: cover;
}
</style>
